import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const LOCALES = ["de", "en", "es"];

/**
 * Three-column localized input.
 * Props:
 *  - label
 *  - value: { de, en, es }
 *  - onChange(next: {de,en,es})
 *  - multi: boolean (textarea)
 *  - rows: textarea rows
 *  - testId: prefix
 *  - required: highlights DE
 */
const LocalizedInput = ({
  label,
  value = { de: "", en: "", es: "" },
  onChange,
  multi = false,
  rows = 3,
  testId = "loc",
  required = false,
}) => {
  const setVal = (l, v) => onChange({ ...value, [l]: v });
  const Comp = multi ? Textarea : Input;

  return (
    <div className="space-y-2">
      {label && (
        <div className="text-xs uppercase tracking-wider text-neutral-500">{label}</div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {LOCALES.map((l) => (
          <div key={l} className="space-y-1">
            <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-400">
              {l.toUpperCase()}
              {required && l === "de" && <span className="text-red-500 ml-1">*</span>}
            </div>
            <Comp
              value={value[l] || ""}
              onChange={(e) => setVal(l, e.target.value)}
              rows={multi ? rows : undefined}
              data-testid={`${testId}-${l}`}
              className="rounded-xl bg-white"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocalizedInput;
